var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "label",
      {
        staticClass:
          "text-xl md_text-base relative cursor-pointer select-none form-input block pl-2_25 md_pl-1_75",
        class: {
          "form-input--radio": !_vm.isUndefined(_vm.value),
          "font-bold": _vm.bold,
          "form-input--small": _vm.small
        }
      },
      [
        _vm._v(_vm._s(_vm.label)),
        _vm.isUndefined(_vm.value)
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checked,
                  expression: "checked"
                }
              ],
              staticClass: "absolute opacity-0 cursor-pointer h-0 w-0",
              attrs: {
                tabindex: "-1",
                type: "checkbox",
                id: _vm.id,
                disabled: _vm.disabled
              },
              domProps: {
                checked: Array.isArray(_vm.checked)
                  ? _vm._i(_vm.checked, null) > -1
                  : _vm.checked
              },
              on: {
                change: function($event) {
                  var $$a = _vm.checked,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.checked = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.checked = $$c
                  }
                }
              }
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.checked,
                  expression: "checked"
                }
              ],
              staticClass: "absolute opacity-0 cursor-pointer h-0 w-0",
              attrs: {
                tabindex: "-1",
                type: "radio",
                id: _vm.id,
                disabled: _vm.disabled
              },
              domProps: {
                value: _vm.value,
                checked: _vm._q(_vm.checked, _vm.value)
              },
              on: {
                change: function($event) {
                  _vm.checked = _vm.value
                }
              }
            }),
        _c("span", {
          staticClass:
            "absolute top-0 left-0 h-full bg-white border-brand-secondary-200 border rounded form-input__mark",
          attrs: {
            tabindex: "0",
            role: _vm.isUndefined(_vm.value) ? "checkbox" : "radio",
            "aria-label": _vm.label,
            "aria-describedby":
              _vm.error && _vm.errorVisible ? _vm.errorId : null,
            "aria-invalid": _vm.error ? "true" : "false",
            "aria-checked": _vm.checked ? "true" : "false",
            "aria-disabled": _vm.disabled ? "true" : "false"
          },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.emitInput($event)
            }
          }
        })
      ]
    ),
    _vm.error && _vm.errorVisible
      ? _c(
          "div",
          { staticClass: "mt-_5 text-error", attrs: { id: _vm.errorId } },
          [_vm._v(_vm._s(_vm.error))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }